angular.module('FlexyBeautyApp.services').factory('Marketplace_Resource', [
    "$resource", "$location",
    function ($resource,$location) {
        let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
        return $resource(baseUrl + 'rest/marketplace', {}, {
            getMarketplaceData: {method: 'GET', url: baseUrl + 'rest/marketplace/data'}
        });
    }
]);

angular.module('FlexyBeautyApp.services').factory('MarketplaceSrv', ['Marketplace_Resource',
    function (Marketplace_Resource) {
        let marketplaceSrv = {};

        marketplaceSrv.getMarketplaceData = function () {
            return Marketplace_Resource.getMarketplaceData().$promise;
        }

        return marketplaceSrv;
    }
]);




// WEBPACK FOOTER //
// ./js/services/models/Marketplace.js